import React, { useEffect } from "react";
import { Box, Button, Text } from "@mantine/core";
import { DEFAULT_THEME } from "../../shared/util/consts";
import { ThemeType } from "../../shared/util/types";

type SubmitTextInterface = {
  instructions?: string;
  subtitle?: string;
  imgSrc?: string;
  maxLength: number;
  onSubmit: (text: string) => void;
  placeholder?: string;
  buttonText?: string;
  additionalComponents?: React.ReactNode;
  theme?: ThemeType;
  addCopySuggestion?: boolean;
};

const SubmitText: React.FC<SubmitTextInterface> = ({
  instructions: title,
  subtitle,
  imgSrc,
  maxLength,
  onSubmit,
  placeholder,
  buttonText,
  additionalComponents,
  theme = DEFAULT_THEME,
  addCopySuggestion = false,
}) => {
  const [text, setText] = React.useState("");
  useEffect(() => {
    setText("");
  }, [title, subtitle]);
  return (
    <Box
      style={{
        width: "60%",
        alignItems: "center",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        justifyContent: "center",
        margin: "20px",
      }}
    >
      {imgSrc && <img src={imgSrc} style={{ width: "100%" }} alt={""} />}
      {title && <Text style={{ fontSize: "20px" }}>{title}</Text>}
      {subtitle && (
        <Text
          style={{
            fontSize: "20px",
            color: theme.ReminderColor,
            marginBottom: "30px",
          }}
        >
          {subtitle}
        </Text>
      )}
      {addCopySuggestion && (
        <Button
          onClick={() => setText(subtitle ?? "")}
          style={{
            backgroundColor: theme.BackgroundColor,
            color: "#CCCCCC",
            fontSize: "16px",
            border: "1px solid #fff",
            borderRadius: "5px",
            margin: "20px",
            height: "30px",
          }}
        >
          Use Suggestion
        </Button>
      )}
      <textarea
        placeholder={placeholder ?? "Enter Text"}
        value={text}
        maxLength={maxLength}
        onChange={(evt) => setText(evt.target.value)}
        style={{
          width: "100%",
          height: "50px",
          minWidth: "200px",
          minHeight: "150px",
          fontFamily: "inherit",
          fontSize: "18px",
        }}
      />
      <Text
        style={{
          fontSize: "14px",
        }}
      >
        {`Remaining characters: ${maxLength - text.length}`}
      </Text>
      <Button
        onClick={() => onSubmit(text)}
        style={{
          backgroundColor: theme.BackgroundColor,
          color: theme.TextColor,
          fontSize: "24px",
          border: "1px solid #fff",
          borderRadius: "5px",
          width: "50%",
          minWidth: "200px",
          marginTop: "20px",
          height: "50px",
        }}
      >
        {buttonText ?? "Submit"}
      </Button>
      {additionalComponents}
    </Box>
  );
};
export default SubmitText;
